import { useMessagingCommunication } from '../MessagingCommunication';

export const useSendMessage = () => {
  const { sendMessage } = useMessagingCommunication();

  return sendMessage;
};
